export default "__VITE_ASSET__BZtmwr8w__"